module.exports = __webpack_public_path__ + "media/images/custom_page/tempest/buy_gacha-2f04bad30ae669ca9f143a51086b497f.png";